import { Flexbox } from '@components/styles/mixins/Flexbox.styled';
import styled from 'styled-components';

export const SModal = styled.article`
width:35%;
${Flexbox({justifyContent:"stretch", alignItems:'stretch', flexDirection:'column'})};
background:${({ theme }) => theme.colors.white};
row-gap:2.4rem;
border:1px solid ${({ theme }) => theme.colors.emerald30};
border-radius:2rem;
padding:2.4rem 3.2rem;
.modal-header{
    ${Flexbox({justifyContent:"space-between", alignItems:"center", flexDirection:"row"})};
    h2{
        font-size:2.2rem;
        font-weight:${({ theme }) => theme.fontWeights.regular};
        color:${({ theme }) => theme.colors.emerald30};
    }
    .close-container{
        ${Flexbox({justifyContent:"flex-end", alignItems:"center", flexDirection:"row"})};
        img{
            cursor:pointer;
            height:1.7rem;
        }
    }
}

`;